import { client } from "Service/axios";
import {
  VEHICLES_OWNER_GROUPS,
  VEHICLES_OWNER_GROUPS_CREATE,
} from "Shared/Constants/apiRequest";
import { IAddOwnerShipGroupType, IOwnerShipGroupType, IOwnerShipGroupTypeSearchList } from "Shared/Types/ownerShipGroupType";

class OwnerShipGroupType {
  async getOwnerShipGroupList(params: IOwnerShipGroupTypeSearchList | null) {
    return client.get<{
      count: number;
      next: string | null;
      previous: string | null;
      results: IOwnerShipGroupType[];
    }>(VEHICLES_OWNER_GROUPS, { params });
  }

  async addOwnerShipGroup(data: IAddOwnerShipGroupType) {
    return client.post<IOwnerShipGroupType>(VEHICLES_OWNER_GROUPS_CREATE, data);
  }
}

export default OwnerShipGroupType;